import { gql } from "apollo-boost";
import { Card } from 'components/common/card/Card';
import { ContentLoader } from 'components/common/loader/ContentLoader';
import { Wrapper } from 'components/common/utils/wrapper/Wrapper';
import OnlyAdmin from 'components/guards/OnlyAdmin';
import * as JSCookie from 'js-cookie';
import { RolesSystem } from "lib/enums/RolesSystem.enum";
import { RouteTo } from 'lib/utils/routing';
import BarGraph from 'pages/dashboard/BarGraph';
import * as React from 'react';
import { Subscription } from "react-apollo";
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import EventDucks from 'stores/ducks/Event.duck';
import UserDucks from 'stores/ducks/User.duck';

const newEvents = gql`
  subscription {
    updatedEvents{
      id
      name
      location
      isActive,
      revenueTotal,
      stripeFeeTotal,
      platFormFeeTotal,
      styling{promoImg}
      totalPrivate,
      totalPublic
      createdBy
      payoutTime
      currency
    }
  }
`;
interface IDashboardOverviewProps {
  token: string;
  events: any[];
  user: any;
  dispatch?: any;
}
class DashboardDefaulPage extends React.Component<IDashboardOverviewProps> {

  public state = {
    loading: true,
    dashboardURL: '',
    updateString: '',
    updatedEvents: [],
    events: [
      {
        isActive: true,
        dailySale: 0,
        averageDayRevenue: 0,
        startTime: '',
        endtime: '',
        location: '',
        creationTimeZone: '',
        _id: '',
        revenueTotal: 0,
        id: '',
        name: '',
        totalPrivate: 0,
        totalPublic: 0,
        displayTime: '',
        timeObject: {
          startYear: 0,
          startMonth: 0,
          startDay: 0,
          startHour: 0,
          startMinutes: 0,
          startAMPM: false,
          endYear: 0,
          endMonth: 0,
          endDay: 0,
          endHour: 0,
          endMinutes: 0,
          endAMPM: false
        },
        currency: ''
      }
    ]
  }

  constructor(props) {
    super(props);
    this.reloadData = this.reloadData.bind(this)
    this.handleRoleChange = this.handleRoleChange.bind(this)
    this.getDashboardURL = this.getDashboardURL.bind(this);
  }

  public handleRoleChange(user: any) {
    this.props.dispatch(UserDucks.setUser(user));
    return undefined;
  }

  public getDashboardURL() {
    fetchGraphQL(`
      query {
        user {
          getStripeDashboardURL(stripeId:"${this.props.user.stripeId}")
        }
      }
    `).then(response => {
      window.location = response.user.getStripeDashboardURL
    })
  }

  public reloadData(e: any, subscription: any) {
    if (subscription === 2) {
      this.setState({
        updateString: e
      })
    } else {
      this.setState({
        updatedEvents: e
      })
    }
    fetchGraphQL(
      `
            {
              event {
                getByCurrentUser {
                  id
                  name
                  isActive
                  location
                  revenueTotal
                  styling {
                    promoImg
                  }
                  currency
                  totalPrivate
                  totalPublic
                  timeObject {
                    startYear
			        			startMonth
			            	startDay
			              startHour
			              startMinutes
                    startAMPM
                  }
                }
              }
            }
          `,
      JSCookie.get("token")
    ).then(result => {
      if (result) {
        const events = result.event.getByCurrentUser
        this.setState({ events, loading: false })
      }
    });
    return undefined
  }

  public componentDidMount() {
    this.setState({ loading: true })
    fetchGraphQL(
      `
            {
              event {
                getByCurrentUser {
                  id
                  name
                  isActive
                  location
                  revenueTotal
                  styling {
                    promoImg
                  }
                  currency
                  totalPrivate
                  totalPublic
                  timeObject {
                    startYear
			        			startMonth
			            	startDay
			              startHour
			              startMinutes
                    startAMPM
                  }
                }
              }
            }
          `,
      JSCookie.get("token")
    ).then(result => {
      if (result) {
        const events = result.event.getByCurrentUser
        this.setState({ events, loading: false })
      }
    });

  }
  public render() {

    let index = 0;
    let index2 = 0;

    const roleChange = gql`
      subscription {
        roleChange
      }
    `;

    let eventIds = ''

    this.state.events.map((item) => {
      eventIds += (item.id + ',');
    })

    const ticketPurchase = gql`
      subscription {
        ticketPurchase(eventIds:"${eventIds}")
      }
    `;

    let activeEvents = 0;
    let totalRevUSD = 0;
    let totalRevINR = 0;

    this.state.events.map(event => {
      if (event.currency && event.currency === 'INR') {
        totalRevINR += (event.revenueTotal || 0);
      } else {
        totalRevUSD += (event.revenueTotal || 0);
      }
      if (event.isActive) {
        activeEvents += 1;
      }
    });

    totalRevUSD /= 100;
    totalRevINR /= 100;

    const sortedEvents = this.state.events.sort((a, b) => {
      return a.startTime > b.startTime ? -1 : a.startTime < b.startTime ? 1 : 0;
    })
    sortedEvents.reverse();

    // So now we are checking for currency
    let currency = 'USD'
    this.state.events.map(event => {
      if (event.currency && event.currency === 'INR') {
        currency = 'INR';
      }
    })

    return (
      <div className='div_holder_2'>
        <div>
          <div>
            <div className="big-split-768">
              <p><br /></p>
            </div>
            <Subscription subscription={roleChange}>
              {({ data }) => {
                if (data !== undefined && data !== null && data.roleChange !== null && data.roleChange.length !== 0) {

                  const events = {}
                  Object.keys(this.props.user.events).map((key) => {
                    if (this.props.user.events[key].id === data.roleChange[1]) {
                      events[key] = { id: this.props.user.events[key].id, roles: [data.roleChange[2]] }
                    } else {
                      events[key] = this.props.user.events[key]
                    }
                  });

                  const newUser = {
                    ...this.props.user,
                    events
                  }
                  this.handleRoleChange(newUser);
                  return <Redirect to="/manage/events" />;
                }
                return null;
              }}
            </Subscription>
            <Subscription subscription={newEvents}>
              {({ data }) => {
                if (data !== undefined && data !== null && data.updatedEvents !== null && data.updatedEvents !== this.state.updatedEvents) {
                  return <img height={0} width={0} onLoad={this.reloadData(data.updatedEvents, 1)} style={{ display: 'none' }} />
                }
                return null;
              }}
            </Subscription>
            <Subscription subscription={ticketPurchase}>
              {({ data }) => {
                if (data !== undefined && data !== null && data.ticketPurchase !== null) {
                  if (data.ticketPurchase !== this.state.updateString) {
                    return <img height={0} width={0} onLoad={this.reloadData(data.ticketPurchase, 2)} style={{ display: 'none' }} />
                  }
                  return null;
                }
                return null;
              }}
            </Subscription>
            {
              this.state.events.length === 0 ?
                <div>
                  <div>
                    <p />
                    <p><br />&nbsp;&nbsp;You have no events.</p>
                  </div>
                </div>
                :
                <ContentLoader isLoading={this.state.loading}>
                  <div className="big-split-768">
                    <p />
                    <Row style={{ width: '100%' }}>
                      <Col style={{ width: '50%' }}>
                        <Card>
                          <div>
                            <p><br /></p>
                            <h3 className='sexyBlack' style={{ width: '100%', textAlign: 'center' }}>Active Events Overview</h3>
                            {this.state.loading ? null : <BarGraph active={activeEvents} numEvents={this.state.events!.length} events={this.state.events} key={totalRevUSD + totalRevINR} />}
                          </div>
                          <p><br /></p>
                        </Card>
                        <p><br /></p>
                        <Card>
                          <div style={{ width: "100%" }}>
                            <p ><br /></p>
                            <div style={{ width: "33%", float: "left", textAlign: "center" }}>
                              Active Events<br />
                              <strong className='sexyBlack'>{activeEvents}</strong>
                            </div>
                            <div style={{ width: "33%", float: "left", textAlign: "center" }}>
                              Total Events<br />
                              <strong className='sexyBlack'> {this.state.events!.length}</strong>
                            </div>
                            <div style={{ width: "33%", float: "right", textAlign: "center" }}>
                              Your All Time Revenue<br />
                              <strong className='sexyBlack'>
                                {
                                  currency === 'INR' ? <span>&#8377;</span> : '$'
                                }
                                {
                                  currency === 'INR' ? totalRevINR.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : totalRevUSD.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                                }
                                <OnlyAdmin>
                                  <br />{'&'}<br />
                                  {'$' + totalRevUSD.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                </OnlyAdmin>
                              </strong>
                            </div>
                          </div>
                          <p><br /></p>
                        </Card>
                      </Col>

                      <Col style={{ width: '50%' }}>
                        <Card>
                          <div>
                            <p />
                            <Wrapper className="overflow-y-none">
                              <div className="scrollable">
                                <table className="w-100 table-responsive--base" style={{ minWidth: '690px' }}>
                                  <thead style={{ width: '95%' }}>
                                    <tr>
                                      <th style={{ textAlign: 'center' }}>INDEX</th>
                                      <th>EVENT</th>
                                      <th>DATE</th>
                                      <th style={{ textAlign: 'center' }}>PRIVATE TICKETS SOLD</th>
                                      <th style={{ textAlign: 'center' }}>PUBLIC TICKETS SOLD</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.events.length > 0 ? (
                                      sortedEvents.map((event) => {
                                        if (event.isActive) {
                                          index += 1;
                                          const timeInfo = event.timeObject
                                          let isHostOrAdmin = false;

                                          if (this.props.user.roles.includes(RolesSystem.ADMIN)) {
                                            isHostOrAdmin = true;
                                          } else {
                                            Object.keys(this.props.user.events).map((key) => {
                                              if (this.props.user.events[key].id === event.id) {
                                                if (this.props.user.events[key].roles.includes(RolesSystem.HOST) || this.props.user.events[key].roles.includes(RolesSystem.ADMIN)) {
                                                  isHostOrAdmin = true;
                                                }
                                              }
                                            });
                                          }

                                          return (
                                            <tr key={"event-" + event._id}>
                                              <td className="sexyBlack" style={{ textAlign: 'center' }}>{index}</td>
                                              <td className="sexyBlack" data-label="Event">
                                                <Link to={RouteTo.eventDetail(event.id)}>
                                                  {event.name}
                                                </Link>
                                              </td>
                                              <td className="sexyBlack" data-label="Date">
                                                {
                                                  timeInfo === undefined ? null : String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
                                                    String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
                                                }
                                                {timeInfo === undefined ? null : timeInfo.startAMPM ? 'PM' : 'AM'}
                                              </td>
                                              <td className="sexyBlack" data-label="Private Tickets" style={{ textAlign: 'center' }} >{event.totalPrivate || 0}</td>
                                              <td className="sexyBlack" data-label="Public Tickets" style={{ textAlign: 'center' }} >{isHostOrAdmin ? (event.totalPublic || 0) : '-'}</td>

                                            </tr>
                                          );
                                        }
                                      })
                                    ) : (
                                        <tr>
                                          <td colSpan={5} className="text-center">
                                            You have no Events
                                            </td>
                                        </tr>
                                      )}
                                  </tbody>
                                </table>
                              </div>
                              <p />
                            </Wrapper>
                          </div>
                        </Card>
                        <p>
                          <br />
                        </p>
                      </Col>
                    </Row>
                  </div>
                  <div className="small-split-768">
                    <p />
                    <Row style={{ width: '100%', paddingRight: '0 auto', paddingLeft: '0 auto', margin: '0 auto' }}>
                      <Col style={{ width: '100%', paddingRight: '0 auto', paddingLeft: '0 auto' }}>
                        <p />
                        <Card style={{ padding: '5%' }}>
                          <div>
                            <p><br /></p>
                            <h3 className='sexyBlack' style={{ width: '100%', textAlign: 'center' }}>Active Events Overview</h3>
                            {this.state.loading ? null : <BarGraph key={totalRevUSD + totalRevINR} active={activeEvents} numEvents={this.state.events!.length} events={this.state.events} />}
                          </div>
                          <p><br /></p>
                        </Card>
                        <p><br /></p>
                        <Card style={{ padding: '5%' }}>
                          <div style={{ width: "100%" }}>
                            <p />
                            <div style={{ width: "33%", float: "left", textAlign: "center" }}>
                              Active Events<br />
                              <strong className='sexyBlack'>{activeEvents}</strong>
                            </div>
                            <div style={{ width: "33%", float: "left", textAlign: "center" }}>
                              Total Events<br />
                              <strong className='sexyBlack'> {this.state.events!.length}</strong>
                            </div>
                            <div style={{ width: "33%", float: "right", textAlign: "center" }}>
                              Your All Time Revenue<br />
                              <strong className='sexyBlack'>
                                {
                                  currency === 'INR' ? <span>&#8377;</span> : '$'
                                }
                                {
                                  currency === 'INR' ? totalRevINR.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : totalRevUSD.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                                }
                                <OnlyAdmin>
                                  <br />+<br />
                                  {'$' + totalRevUSD.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                </OnlyAdmin>
                              </strong>
                            </div>
                          </div>
                          <p />
                        </Card>
                        <p><br /></p>
                        <Card>
                          <div>
                            <p />
                            <Wrapper className="overflow-y-none">
                              <div className="scrollable">
                                <table className="w-100 table-responsive--base" style={{ minWidth: '690px' }}>
                                  <thead style={{ width: '95%' }}>
                                    <tr>
                                      <th style={{ textAlign: 'center' }}>INDEX</th>
                                      <th>EVENT</th>
                                      <th>DATE</th>
                                      <th style={{ textAlign: 'center' }}>PRIVATE TICKETS SOLD</th>
                                      <th style={{ textAlign: 'center' }}>PUBLIC TICKETS SOLD</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.events.length > 0 ? (
                                      sortedEvents.map((event) => {
                                        if (event.isActive) {
                                          index2 += 1;
                                          const timeInfo = event.timeObject
                                          let isHostOrAdmin = false;

                                          if (this.props.user.roles.includes(RolesSystem.ADMIN)) {
                                            isHostOrAdmin = true;
                                          } else {
                                            Object.keys(this.props.user.events).map((key) => {
                                              if (this.props.user.events[key].id === event.id) {
                                                if (this.props.user.events[key].roles.includes(RolesSystem.HOST) || this.props.user.events[key].roles.includes(RolesSystem.ADMIN)) {
                                                  isHostOrAdmin = true;
                                                }
                                              }
                                            });
                                          }

                                          return (
                                            <tr key={"event-" + event._id}>
                                              <td className="sexyBlack" style={{ textAlign: 'center' }}>{index2}</td>
                                              <td className="sexyBlack" data-label="Event">
                                                <Link to={RouteTo.eventDetail(event.id)}>
                                                  {event.name}
                                                </Link>
                                              </td>
                                              <td className="sexyBlack" data-label="Date">
                                                {
                                                  timeInfo === undefined ? null : String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
                                                    String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
                                                }
                                                {timeInfo === undefined ? null : timeInfo.startAMPM ? 'PM' : 'AM'}
                                              </td>
                                              <td className="sexyBlack" data-label="Private Tickets" style={{ textAlign: 'center' }} >{event.totalPrivate || 0}</td>
                                              <td className="sexyBlack" data-label="Public Tickets" style={{ textAlign: 'center' }} >{isHostOrAdmin ? (event.totalPublic || 0) : '-'}</td>

                                            </tr>
                                          );
                                        }
                                      })
                                    ) : (
                                        <tr>
                                          <td colSpan={5} className="text-center">
                                            You have no Events
                                            </td>
                                        </tr>
                                      )}
                                  </tbody>
                                </table>
                              </div>
                              <p />
                            </Wrapper>
                          </div>
                        </Card>
                      </Col>
                    </Row>
                    <p><br /></p>
                  </div>

                </ContentLoader>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: UserDucks.getToken(state),
    events: EventDucks.getEvents(state),
    user: UserDucks.getUser(state)
  };
};

export default connect(mapStateToProps)(DashboardDefaulPage);


// WEBPACK FOOTER //
// ./src/pages/dashboard/Overview.page.tsx